import * as log from 'loglevel';
import * as ko from 'knockout';
import {registerMainMenuScreenComponent} from "../screens/main-menu/MainMenuScreen";
import {registerGameplayScreenComponent} from "../screens/gameplay/GamePlayScreen";
import {registerGameOverScreenComponent} from "../screens/gameplay/game-over/GameOverScreen";
import {registerGameplayLeaderboardScreenComponent} from "../screens/gameplay/leaderboard/LeaderboardScreen";
import {registerGameplayPauseOverlayComponent} from "../screens/gameplay/pause-menu/PauseOverlay";
import {registerGameplayQuestionOverlayComponent} from '../screens/gameplay/questions/QuestionOverlayComponent';
import {registerInstructionsScreenComponent} from '../screens/instructions/InstructionsScreen';
import {registerOrientationWarningScreenComponent} from '../screens/device-orientation-warning/OrientationWarningScreen';
import {registerLeaderboardScreenComponent} from '../screens/leaderboard/LeaderboardScreen';
import {registerGameIntroScreenComponent} from '../screens/gameplay/game-intro/GameIntroScreen';
import {registerLevelIntroScreenComponent} from '../screens/gameplay/level-intro/LevelIntroScreen';
import {registerSortingGameOverlayComponent} from "../screens/gameplay/sorting-game/SortingGameOverlayComponent";
import {registerDifficultySelectScreenComponent} from "../screens/main-menu/difficulty-select/DifficultySelectScreen";
import {registerClickOrTapBinding} from './InteractiveElementBinding';


/**
 * register all custom knockout components we want to use
 */
export function registerCustomComponents()
{
    //  register custom bindings

    registerClickOrTapBinding();

    //  register components

    registerMainMenuScreenComponent();
    registerLeaderboardScreenComponent();
    registerInstructionsScreenComponent();
    registerOrientationWarningScreenComponent();

    //  gameplay components

    registerGameplayPauseOverlayComponent();
    registerGameplayQuestionOverlayComponent();
    registerGameplayLeaderboardScreenComponent();
    registerGameOverScreenComponent();
    registerGameplayScreenComponent();
    registerGameIntroScreenComponent();
    registerLevelIntroScreenComponent();

    //  register new recycling game components

    registerDifficultySelectScreenComponent();
    registerSortingGameOverlayComponent();
}


// WEBPACK FOOTER //
// ./src/ts/components/RegisterComponents.ts